import { apiClient } from '@/infrastructure/api'
import {
  ChatApi,
  ChatpbChatMessage,
  ChatpbChatRequest,
  ChatpbChatResponse
} from '@itsrever/rever-api'

export const chatApi = new ChatApi(undefined, undefined, apiClient)

interface SendChatArgs {
  ecommerceId: string
  messages: ChatpbChatMessage[]
  payload: object
  // Audience-scoped Auth0 token a context's Mastra tools forward as-is (e.g.
  // analytics); omitted entirely for contexts that don't need one.
  mcpAccessToken?: string
}

export async function sendChat({
  ecommerceId,
  messages,
  payload,
  mcpAccessToken
}: SendChatArgs): Promise<ChatpbChatResponse> {
  const response = await chatApi.chat({
    ecommerceId,
    // mcp_access_token isn't in the generated type yet (regenerated in CI); cast until it lands.
    chatpbChatRequest: {
      ecommerce_id: ecommerceId,
      messages,
      payload,
      ...(mcpAccessToken ? { mcp_access_token: mcpAccessToken } : {})
    } as ChatpbChatRequest
  })

  return response.data
}
